import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  arrowContainer,
  bannerContainer,
  diamondIcon,
  diamondShape,
  iconContainer,
  text,
  textContainer,
  tonIcon
} from './styles';

import DiamondSimpleShape from '@/components/common/svg/shapes/DiamondSimpleShape.tsx';
import TONShape from '@/components/common/svg/shapes/TONShape.tsx';
import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import Modal from '@/animations/Modal.tsx';
import UnlockBonusesPopup from '@/components/EarnTon/Challenges/UnlockBonusesPopup/UnlockBonusesPopup.tsx';

const ChallengesBanner: FC = () => {
  const { t } = useTranslation();
  const [unlockBonusesPopupOpen, setUnlockBonusesPopupOpen] = useState(false);

  const closeUnlockBonusesPopup = () => setUnlockBonusesPopupOpen(false);
  const openUnlockBonusesPopup = () => setUnlockBonusesPopupOpen(true);

  return (
    <>
      <div style={bannerContainer} onClick={() => openUnlockBonusesPopup()}>
        <div style={iconContainer}>
          <div style={tonIcon}>
            <TONShape width={45} height={45} fillColor="#fff" />
          </div>
          <div style={diamondIcon}>
            <DiamondSimpleShape
              width={45}
              height={45}
              fillColor="#FFF"
              style={diamondShape}
            />
          </div>
        </div>
        <div style={textContainer}>
          <span style={text}>
            {t('earn.unlock_challenges_by_incoming_activity')}
          </span>
        </div>
        <div style={arrowContainer}>
          <ArrowRightShape height={11} width={11} />
        </div>
      </div>

      <Modal
        open={unlockBonusesPopupOpen}
        handleClose={closeUnlockBonusesPopup}
      >
        <UnlockBonusesPopup handleClose={closeUnlockBonusesPopup} />
      </Modal>
    </>
  );
};

export default ChallengesBanner;
